"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFilers = exports.clearFilter = exports.toggleFilter = void 0;
var filters_reducers_enhancer_1 = require("./filters.reducers-enhancer");
var toggleFilter = function (entityName, sectionKey, filterKey) { return function (dispatch) {
    dispatch({
        type: (0, filters_reducers_enhancer_1.UPDATE)(entityName),
        payload: {
            sectionKey: sectionKey,
            filterKey: filterKey
        }
    });
}; };
exports.toggleFilter = toggleFilter;
var clearFilter = function (entityName) { return function (dispatch) {
    dispatch({
        type: (0, filters_reducers_enhancer_1.CLEAR)(entityName)
    });
}; };
exports.clearFilter = clearFilter;
var replaceFilers = function (entityName, filters) { return function (dispatch) {
    dispatch({
        type: (0, filters_reducers_enhancer_1.REPLACE)(entityName),
        payload: filters
    });
}; };
exports.replaceFilers = replaceFilers;
//# sourceMappingURL=filters.actions.js.map